export const SET_INFO_SESSION = 'SET_INFO_SESSION'
export const SET_INFO_PERMISSOES = 'SET_INFO_PERMISSOES'
export const SET_INFO_MENU_FILTRADO = 'SET_INFO_MENU_FILTRADO'
export const SET_CLEAN_INFO_USER = 'SET_CLEAN_INFO_USER'
export const SET_HASH = 'SET_HASH'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js